import {
  AdvancedQueryColumnFilter,
  AdvancedQueryColumnSort,
  LogSummaryGroupListItem,
  LogSummaryDetailDto,
  LogSummaryListDto,
  LogSummaryGetDto,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  OptionItemDto,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class LogSummariesService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static getAll(
    params: {
      /**  */
      onlyImportant?: boolean;
      /**  */
      onlyUnresolved?: boolean;
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<LogSummaryGroupListItem>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/log-summaries';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OnlyImportant: params['onlyImportant'],
        OnlyUnresolved: params['onlyUnresolved'],
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<LogSummaryDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/log-summaries/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByGroup(
    params: {
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
      /**  */
      parameters: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<LogSummaryListDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/log-summaries/{parameters}/by-group';
      url = url.replace('{parameters}', params['parameters'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static resolveGroup(
    params: {
      /**  */
      parameters: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<LogSummaryGetDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/log-summaries/{parameters}/resolve-group';
      url = url.replace('{parameters}', params['parameters'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateHandledStatus(
    params: {
      /**  */
      id: number;
      /**  */
      status?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<LogSummaryGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/log-summaries/{id}/update-handle-status';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { status: params['status'] };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
